import { render } from "./ComponentDialogExport.vue?vue&type=template&id=2957ce41"
import script from "./ComponentDialogExport.vue?vue&type=script&lang=js"
export * from "./ComponentDialogExport.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__